import type {
  ExplicitMeasurementGoal,
  MeasurementGoalCreate,
  MeasurementGoalUpdate,
} from "@/types/measurement";

import { requestData } from "@/api/api-config";

export async function getPatientGoals(
  patientId: string,
): Promise<ExplicitMeasurementGoal[] | null> {
  return await requestData<ExplicitMeasurementGoal[]>(
    `user/patient/measurement-goals/${patientId}`,
    "get",
  );
}

export async function getFieldGoal(
  patientId: string,
  fieldId: string,
): Promise<ExplicitMeasurementGoal | null> {
  return await requestData<ExplicitMeasurementGoal>(
    `user/patient/measurement-goals/${patientId}/field/${fieldId}`,
    "get",
  );
}

export async function setMeasurementGoal(
  data: MeasurementGoalCreate,
): Promise<ExplicitMeasurementGoal | null> {
  return await requestData<ExplicitMeasurementGoal>(
    "user/patient/measurement-goals",
    "post",
    { json: data },
  );
}

export async function updateMeasurementGoal(
  patientId: string,
  goalId: string,
  data: MeasurementGoalUpdate,
): Promise<ExplicitMeasurementGoal | null> {
  return await requestData<ExplicitMeasurementGoal>(
    `user/patient/measurement-goals/${patientId}/goal/${goalId}`,
    "put",
    { json: data },
  );
}

export async function deleteMeasurementGoal(
  patientId: string,
  goalId: string,
): Promise<void> {
  await requestData(
    `user/patient/measurement-goals/${patientId}/goal/${goalId}`,
    "delete",
  );
}
